/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home/Home' }">Home</el-breadcrumb-item>
    <el-breadcrumb-item>Alarm Overview</el-breadcrumb-item>
  </el-breadcrumb>
  <p></p>
  <dashboard v-bind:child-msg="data"></dashboard>
  </div>
</template>

<script>
import dashboard from '@/components/dashboard'
import { userList, getTotal, getAlarmData } from '../../api/userMG'
export default {
  data() {
    return {
      data: {
        statusObject: [{title: 'Alarm Total',number: 0},{title: 'Guaranttee',number: 0},{title: 'Out Guaranttee',number: 0},{title: 'Failure',number: 0}],
        dataList: {
            "Alarm Total": {
              expectedData: [],
              actualData: [],
              statusData: ['Failure', 'normal']
            },
            Guaranttee: {
              expectedData: [],
              actualData: [],
              statusData: ['Out Guaranttee', 'Guaranttee']
            },
            "Out Guaranttee": {
              expectedData: [],
              actualData: [],
              statusData: ['Out Guaranttee', 'Guaranttee']
            },
            Failure: {
              expectedData: [],
              actualData: [],
              statusData: ['Failure', 'normal']
            }
          },
        data: [
          {
            prop:'softwareSerialNumber',
            label:'Machine S/N',
           },
          {
            prop:'machineName',
            label:'Machine Name',
           },
          {
            prop:'belonging',
            label:'Beauty Center',
            title: 'Assign Beauty Center or not'
           },
          {
            prop:'errorMsg',
            label:'Alarm Information',
           },
          {
            prop:'errorDetails',
            label:'Alarm Details',
           },
          {
            prop:'status',
            label:'Status',
          },
          {
            prop:'creationTime',
            label:'Creation time',
          }
        ],
        listData: []
      },
      beginTime: '',
      endTime: '',
      machineTotal: '',
      disableTotal: '',
      AlarmTotal: '',
      mon: '',
      tue: '',
      wed: '',
      thu: '',
      fri: '',
      sat: '',
      sun: '',
      AlarmFormline: {
        page: 1,
        serialNumber: '',
        machineName: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        errorMsg: '',
        status: '',
        creationTime: ''
      },
      offlineExpectedData: [],
      onlineActualData : [],
      disableExpectedData : [],
      normalActualData : []
     }
  },
  // 注册组件
  components: {
    dashboard
  },
  /**
   * 创建完毕
   */
  created() {
    this.getLastWeek();
    this.getMachineTotal();
    this.getMachineFailure();
    this.getAlarmTotal();
    this.getOnlineTotal();
    this.getOfflineTotal();
    this.getData();
    this.getAlarmList(this.AlarmFormline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getLastWeek(){
      // 获取上一周的开始和结束时间
      var mon,tue,wed,thu,fri,sat,sun;
      var myDate = new Date();
      var weekDate = new Date(myDate.getTime() - 7 * 24 * 3600 * 1000);// 计算开始时间用
      var weekDate2 = new Date(myDate.getTime() - 7 * 24 * 3600 * 1000);// 计算结束时间用

      var day = weekDate.getDay();
      var time = weekDate.getDate()-day+(day===0?-6:1);

      var startDate = new Date(weekDate.setDate(time));
      var endDate = new Date(weekDate2.setDate(time+6));

      var beginFullYear = startDate.getFullYear();
      var beginMonth = startDate.getMonth() + 1;
      var beginDay = startDate.getDate();

      var endFullYear = endDate.getFullYear();
      var endMonth = endDate.getMonth() + 1;
      var endDay = endDate.getDate();

      this.beginTime = beginFullYear + '-' + beginMonth + '-' + beginDay;
      this.endTime = endFullYear + '-' + endMonth + '-' + endDay;
      this.mon = this.beginTime;
      this.tue = beginFullYear + '-' + beginMonth + '-' + (beginDay + 1);
      this.wed = beginFullYear + '-' + beginMonth + '-' + (beginDay + 2);
      this.thu = beginFullYear + '-' + beginMonth + '-' + (beginDay + 3);
      this.fri = beginFullYear + '-' + beginMonth + '-' + (beginDay + 4);
      this.sat = beginFullYear + '-' + beginMonth + '-' + (beginDay + 5);
      this.sun = this.endTime;

    },
    getAlarmList(parm){
      getAlarmData(parm)
        .then(res => {
          if(res.code === 201){
            this.data.listData = res.data;
          }
        })
    },
    getMachineTotal(){
      var obj = {dbName: 'machine'}
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            this.machineTotal = res.data
          }
        })
    },
    getMachineFailure(){
      var obj = {dbName: 'machine',status:'failure', }
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            this.data.statusObject[3].number = res.data;
            this.disableTotal = res.data;
          }
        })
    },
    getAlarmTotal(){
      var obj = {dbName: 'alarm', belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : ''}
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            this.AlarmTotal = res.data
            this.data.statusObject[0].number = this.AlarmTotal;
            console.log(res,"total:" + this.AlarmTotal,'@@@@@@@@@@@@');
          }
        })
    },
    getOnlineTotal(){
      var obj = {dbName: 'alarm',status: 'Guaranttee', belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : ''}
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            this.data.statusObject[1].number = res.data;
            console.log(res,'!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
          }
        })
    },
    getOfflineTotal(){
      var obj = {dbName: 'alarm',status: 'Out Guaranttee', belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : ''}
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            this.data.statusObject[2].number = res.data;
            console.log(res);
          }
        })
    },
    getData(){
      this.getLastMonData();
      this.getLastTueData();
      this.getLastWedData();
      this.getLastThuData();
      this.getLastFriData();
      this.getLastSatData();
      this.getLastSunData();
    },
    getLastMonData(){
      var obj = { belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '' };
      obj.alarmdbName = 'alarm'
      obj.mon = Math.round(new Date(this.mon) / 1000);
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            var offlineNum = res.disableTotal;
            var normalNum = this.machineTotal - res.disableTotal;
            this.offlineExpectedData.push(offlineNum)
            this.onlineActualData.push(res.onlineTotal)
            this.disableExpectedData.push(offlineNum)
            this.normalActualData.push(normalNum)

            this.data.dataList["Alarm Total"].expectedData = this.disableExpectedData
            this.data.dataList["Alarm Total"].actualData = this.normalActualData
            this.data.dataList.Guaranttee.expectedData = this.offlineExpectedData
            this.data.dataList.Guaranttee.actualData = this.onlineActualData
            this.data.dataList["Out Guaranttee"].expectedData = this.offlineExpectedData
            this.data.dataList["Out Guaranttee"].actualData = this.onlineActualData
            this.data.dataList.Failure.expectedData = this.disableExpectedData
            this.data.dataList.Failure.actualData = this.normalActualData
            console.log(this.machineTotal,this.normalActualData,'!@!@@@@@@@@@@@@@@@@@@@@@@@!!!!!!!!!@!@!@');
          }
          })
    },
    getLastTueData(){
      var obj = {  }
      obj.alarmdbName = 'alarm'
      obj.tue = Math.round(new Date(this.tue) / 1000);
      obj.belonging = JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : ''
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            var offlineNum = res.disableTotal;
            var normalNum = this.machineTotal - res.disableTotal;
            this.offlineExpectedData.push(offlineNum)
            this.onlineActualData.push(res.onlineTotal)
            this.disableExpectedData.push(offlineNum)
            this.normalActualData.push(normalNum)

            this.data.dataList["Alarm Total"].expectedData = this.disableExpectedData
            this.data.dataList["Alarm Total"].actualData = this.normalActualData
            this.data.dataList.Guaranttee.expectedData = this.offlineExpectedData
            this.data.dataList.Guaranttee.actualData = this.onlineActualData
            this.data.dataList["Out Guaranttee"].expectedData = this.offlineExpectedData
            this.data.dataList["Out Guaranttee"].actualData = this.onlineActualData
            this.data.dataList.Failure.expectedData = this.disableExpectedData
            this.data.dataList.Failure.actualData = this.normalActualData
            console.log(this.offlineExpectedData);


          }
        })
    },
    getLastWedData(){
      var obj = {belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : ''};
      obj.alarmdbName = 'alarm'
      obj.wed = Math.round(new Date(this.wed) / 1000);
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            var offlineNum = res.disableTotal;
            var normalNum = this.machineTotal - res.disableTotal;
            this.offlineExpectedData.push(offlineNum)
            this.onlineActualData.push(res.onlineTotal)
            this.disableExpectedData.push(offlineNum)
            this.normalActualData.push(normalNum)

            this.data.dataList["Alarm Total"].expectedData = this.disableExpectedData
            this.data.dataList["Alarm Total"].actualData = this.normalActualData
            this.data.dataList.Guaranttee.expectedData = this.offlineExpectedData
            this.data.dataList.Guaranttee.actualData = this.onlineActualData
            this.data.dataList["Out Guaranttee"].expectedData = this.offlineExpectedData
            this.data.dataList["Out Guaranttee"].actualData = this.onlineActualData
            this.data.dataList.Failure.expectedData = this.disableExpectedData
            this.data.dataList.Failure.actualData = this.normalActualData
            console.log(res);
          }
        })
    },
    getLastThuData(){
      var obj = {belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : ''};
      obj.alarmdbName = 'alarm'
      obj.thu = Math.round(new Date(this.thu) / 1000);
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            var offlineNum = res.disableTotal;
            var normalNum = this.machineTotal - res.disableTotal;
            this.offlineExpectedData.push(offlineNum)
            this.onlineActualData.push(res.onlineTotal)
            this.disableExpectedData.push(offlineNum)
            this.normalActualData.push(normalNum)

            this.data.dataList["Alarm Total"].expectedData = this.disableExpectedData
            this.data.dataList["Alarm Total"].actualData = this.normalActualData
            this.data.dataList.Guaranttee.expectedData = this.offlineExpectedData
            this.data.dataList.Guaranttee.actualData = this.onlineActualData
            this.data.dataList["Out Guaranttee"].expectedData = this.offlineExpectedData
            this.data.dataList["Out Guaranttee"].actualData = this.onlineActualData
            this.data.dataList.Failure.expectedData = this.disableExpectedData
            this.data.dataList.Failure.actualData = this.normalActualData
            console.log(res);
          }
        })
    },
    getLastFriData(){
      var obj = {belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : ''};
      obj.alarmdbName = 'alarm'
      obj.fri = Math.round(new Date(this.fri) / 1000);
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            var offlineNum = res.disableTotal;
            var normalNum = this.machineTotal - res.disableTotal;
            this.offlineExpectedData.push(offlineNum)
            this.onlineActualData.push(res.onlineTotal)
            this.disableExpectedData.push(offlineNum)
            this.normalActualData.push(normalNum)

            this.data.dataList["Alarm Total"].expectedData = this.disableExpectedData
            this.data.dataList["Alarm Total"].actualData = this.normalActualData
            this.data.dataList.Guaranttee.expectedData = this.offlineExpectedData
            this.data.dataList.Guaranttee.actualData = this.onlineActualData
            this.data.dataList["Out Guaranttee"].expectedData = this.offlineExpectedData
            this.data.dataList["Out Guaranttee"].actualData = this.onlineActualData
            this.data.dataList.Failure.expectedData = this.disableExpectedData
            this.data.dataList.Failure.actualData = this.normalActualData
            console.log(res);
          }
          })
    },
    getLastSatData(){
      var obj = {belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : ''};
      obj.alarmdbName = 'alarm'
      obj.sat = Math.round(new Date(this.sat) / 1000);
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            var offlineNum = res.disableTotal;
            var normalNum = this.machineTotal - res.disableTotal;
            this.offlineExpectedData.push(offlineNum)
            this.onlineActualData.push(res.onlineTotal)
            this.disableExpectedData.push(offlineNum)
            this.normalActualData.push(normalNum)

            this.data.dataList["Alarm Total"].expectedData = this.disableExpectedData
            this.data.dataList["Alarm Total"].actualData = this.normalActualData
            this.data.dataList.Guaranttee.expectedData = this.offlineExpectedData
            this.data.dataList.Guaranttee.actualData = this.onlineActualData
            this.data.dataList["Out Guaranttee"].expectedData = this.offlineExpectedData
            this.data.dataList["Out Guaranttee"].actualData = this.onlineActualData
            this.data.dataList.Failure.expectedData = this.disableExpectedData
            this.data.dataList.Failure.actualData = this.normalActualData
            console.log(res);
          }
          })
    },
    getLastSunData(){
      var obj = {belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : ''};
      obj.alarmdbName = 'alarm'
      obj.sun = Math.round(new Date(this.sun) / 1000);
      getTotal(obj)
        .then(res => {
          if(res.code === 201){
            var offlineNum = res.disableTotal;
            var normalNum = this.machineTotal - res.disableTotal;
            this.offlineExpectedData.push(offlineNum)
            this.onlineActualData.push(res.onlineTotal)
            this.disableExpectedData.push(offlineNum)
            this.normalActualData.push(normalNum)

            this.data.dataList["Alarm Total"].expectedData = this.disableExpectedData
            this.data.dataList["Alarm Total"].actualData = this.normalActualData
            this.data.dataList.Guaranttee.expectedData = this.offlineExpectedData
            this.data.dataList.Guaranttee.actualData = this.onlineActualData
            this.data.dataList["Out Guaranttee"].expectedData = this.offlineExpectedData
            this.data.dataList["Out Guaranttee"].actualData = this.onlineActualData
            this.data.dataList.Failure.expectedData = this.disableExpectedData
            this.data.dataList.Failure.actualData = this.normalActualData
            console.log(res,'@@@@@@@@@@@@@@@@@@@');
          }
          })
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.serialnNmber-tag{
  width: 82%;
  min-height: 60px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
.el-drawer__body>* {
  box-sizing: border-box;
}
.el-tag.el-tag--info{
  margin-left: 10px;
}
.demo-drawer__content {
  display: flex;
  flex-direction: column;
  padding: 20px;
  height: 100%;
}
.demo-drawer__footer{
  display: flex;
}
.demo-drawer__content form{
  flex: 1;
}
.demo-drawer__footer button{
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/alarmOverview/index.vue